import HomeLayout from './Home'

export default HomeLayout
